export default "__VITE_ASSET__Ct$8nd78__"